import { Injectable } from '@angular/core';
import { CoordonneesCompteBancairePrelevement } from '../MIF.Subscription.Parrot';
import { BankAccountDetails } from '../MIF.Subscription.WebApi';
import { ParrotService } from './parrot.service';

@Injectable({
  providedIn: 'root'
})
export class WsCoordonneesBancairesService {
  constructor(private parrotService: ParrotService) {}

  public async getCoordonneesComptesBancairesPrelevementArray(): Promise<CoordonneesCompteBancairePrelevement[]> {
    const bankAccountDetails = await this.parrotService.getBankAccountDetails();

    return bankAccountDetails.map((item: BankAccountDetails) => {
      return this.mapBankAccountDetails(item);
    });
  }

  private mapBankAccountDetails(item: BankAccountDetails): CoordonneesCompteBancairePrelevement {
    return new CoordonneesCompteBancairePrelevement({
      iBAN: item.iban,
      bIC: item.bic,
      rUM: item.rum,
      numeroContrat: item.contractNumbers
    });
  }
}
